function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import Loading from "../../helperComponents/Loading/Loading";
import { getIndexQueryKey } from "./actions/PolizaEndorsementActions";
import "./poliza_endorsement.scss";
import { FilePond } from "react-filepond";
import "filepond/dist/filepond.min.css";
import { getFormattedDate } from "../../utils/datetime";
import { getEndorsementDocumentFilename } from "./utils";

var PolizaEndorsementListItem = function PolizaEndorsementListItem(props) {
  var polizaEndorsement = props.polizaEndorsement,
      admin = props.admin;
  var queryClient = useQueryClient();

  var _React$useState = React.useState(polizaEndorsement),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      endorsement = _React$useState2[0],
      setEndorsement = _React$useState2[1];

  var indexQueryKey = getIndexQueryKey(polizaEndorsement.poliza_id);
  var last_update_by = "por ".concat(endorsement.updated_by_email, " el  ").concat(getFormattedDate(endorsement.updated_at));

  var refreshList = function refreshList() {
    queryClient.invalidateQueries({
      queryKey: indexQueryKey
    });
  };

  var hasEditPermission = admin.is_super_admin || admin.permissions_code.includes("poliza_endorsement_edit");
  var canApproveAndReject = admin.is_super_admin || admin.permissions_code.includes("poliza_endorsement_approve_reject");
  var isAbleToEdit = (endorsement === null || endorsement === void 0 ? void 0 : endorsement.aasm_state) === "pending";

  var _useMutation = useMutation({
    mutationFn: function mutationFn() {
      return axios.put("/api/v1/poliza_endorsements/".concat(polizaEndorsement.id, "/approve"));
    },
    onSuccess: function onSuccess(response) {
      refreshList();
      setEndorsement(response.data);
      window.location.reload();
    }
  }),
      isLoadingApprove = _useMutation.isLoading,
      errorApprove = _useMutation.error,
      approvePolizaEndorsement = _useMutation.mutate,
      approvedPolizaEndorsement = _useMutation.data;

  var _useMutation2 = useMutation({
    mutationFn: function mutationFn() {
      return axios.post("/api/v1/poliza_endorsements/".concat(polizaEndorsement.id, "/reject"));
    },
    onSuccess: function onSuccess(response) {
      refreshList();
      setEndorsement(response.data);
    }
  }),
      isLoadingReject = _useMutation2.isLoading,
      errorReject = _useMutation2.error,
      rejectPolizaEndorsement = _useMutation2.mutate,
      rejectedPolizaEndorsement = _useMutation2.data;

  var _useMutation3 = useMutation({
    mutationFn: function mutationFn() {
      return axios.get("/api/v1/poliza_endorsements/".concat(polizaEndorsement.id));
    },
    onSuccess: function onSuccess(response) {
      setEndorsement(response.data);
    }
  }),
      isLoading = _useMutation3.isLoading,
      error = _useMutation3.error,
      refreshPolizaEndorsement = _useMutation3.mutate,
      refreshedPolizaEndorsement = _useMutation3.data;

  var refreshEndorsement = function refreshEndorsement(response) {
    refreshPolizaEndorsement();
    return response;
  };

  var submitApprove = function submitApprove() {
    approvePolizaEndorsement();
  };

  var submitReject = function submitReject() {
    rejectPolizaEndorsement();
  };

  var renderApproveButton = function renderApproveButton() {
    if (isLoadingApprove) return /*#__PURE__*/React.createElement("button", {
      className: "btn btn-disabled"
    }, /*#__PURE__*/React.createElement(Loading, null));
    if (errorApprove) return "error!";

    if (endorsement.permitted_events.find(function (e) {
      return e === "approve";
    }) && isAbleToEdit) {
      return /*#__PURE__*/React.createElement("button", {
        className: "btn btn-success ",
        title: "Aprobar",
        onClick: submitApprove
      }, /*#__PURE__*/React.createElement("i", {
        className: "glyphicon glyphicon-ok"
      }), "Aprobar");
    } else {
      return;
    }
  };

  var renderRejectButton = function renderRejectButton() {
    if (isLoadingReject) return /*#__PURE__*/React.createElement("button", {
      className: "btn btn-disabled"
    }, /*#__PURE__*/React.createElement(Loading, null));
    if (errorReject) return "error!";

    if (endorsement.permitted_events.find(function (e) {
      return e === "reject";
    }) && isAbleToEdit) {
      return /*#__PURE__*/React.createElement("button", {
        className: "btn btn-danger",
        title: "Rechazar",
        onClick: submitReject
      }, /*#__PURE__*/React.createElement("i", {
        className: "glyphicon glyphicon-remove"
      }), "Rechazar");
    } else {
      return;
    }
  };

  if (!endorsement) return null;

  var renderAmountDiff = function renderAmountDiff(new_amount, diff, label) {
    var sign = diff && diff > 0 ? "+" : "";
    return diff && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("dt", null, label, ":"), /*#__PURE__*/React.createElement("dd", null, "".concat(endorsement.currency, " ").concat(new_amount), /*#__PURE__*/React.createElement("small", {
      className: sign === "+" ? "text-success" : "text-danger"
    }, "(".concat(sign, " ").concat(diff, ") "))));
  };

  var renderAmountCommissionDiff = function renderAmountCommissionDiff() {
    var _endorsement$poliza_p, _endorsement$poliza_p2, _endorsement$poliza_p3, _endorsement$poliza_p4, _endorsement$poliza_p5;

    var diff = parseFloat(endorsement === null || endorsement === void 0 ? void 0 : (_endorsement$poliza_p = endorsement.poliza_params) === null || _endorsement$poliza_p === void 0 ? void 0 : _endorsement$poliza_p.amount_change_difference);
    var new_asegurado_amount = parseFloat((_endorsement$poliza_p2 = endorsement.poliza_params) === null || _endorsement$poliza_p2 === void 0 ? void 0 : _endorsement$poliza_p2.new_asegurado_amount);
    var sign = diff && diff > 0 ? "+" : "";
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderCommissionDiff(), ((_endorsement$poliza_p3 = endorsement.poliza_params) === null || _endorsement$poliza_p3 === void 0 ? void 0 : _endorsement$poliza_p3.amount_change_date) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("dt", null, "Fecha de Aumento/Rebaja:"), /*#__PURE__*/React.createElement("dd", null, (_endorsement$poliza_p4 = endorsement.poliza_params) === null || _endorsement$poliza_p4 === void 0 ? void 0 : _endorsement$poliza_p4.amount_change_date)), ((_endorsement$poliza_p5 = endorsement.poliza_params) === null || _endorsement$poliza_p5 === void 0 ? void 0 : _endorsement$poliza_p5.amount_change_difference) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("dt", null, "Monto Asegurado:"), /*#__PURE__*/React.createElement("dd", null, "".concat(endorsement.currency, " ").concat(new_asegurado_amount), /*#__PURE__*/React.createElement("small", {
      className: sign === "+" ? "text-success" : "text-danger"
    }, "(".concat(sign, " ").concat(diff, ") ")))));
  };

  var renderCommissionDiff = function renderCommissionDiff() {
    var _endorsement$poliza_p6, _endorsement$poliza_p7, _endorsement$poliza_p8, _endorsement$poliza_p9, _endorsement$poliza_p10, _endorsement$poliza_p11, _endorsement$poliza_p12, _endorsement$poliza_p13, _endorsement$poliza_p14, _endorsement$poliza_p15;

    return /*#__PURE__*/React.createElement(React.Fragment, null, renderAmountDiff((_endorsement$poliza_p6 = endorsement.poliza_params) === null || _endorsement$poliza_p6 === void 0 ? void 0 : (_endorsement$poliza_p7 = _endorsement$poliza_p6.commission) === null || _endorsement$poliza_p7 === void 0 ? void 0 : _endorsement$poliza_p7.affects_net_bonus, endorsement.affects_net_bonus, "Prima neta afecta"), renderAmountDiff((_endorsement$poliza_p8 = endorsement.poliza_params) === null || _endorsement$poliza_p8 === void 0 ? void 0 : (_endorsement$poliza_p9 = _endorsement$poliza_p8.commission) === null || _endorsement$poliza_p9 === void 0 ? void 0 : _endorsement$poliza_p9.exempt_net_bonus, endorsement.exempt_net_bonus, "Prima neta exenta"), renderAmountDiff((_endorsement$poliza_p10 = endorsement.poliza_params) === null || _endorsement$poliza_p10 === void 0 ? void 0 : (_endorsement$poliza_p11 = _endorsement$poliza_p10.commission) === null || _endorsement$poliza_p11 === void 0 ? void 0 : _endorsement$poliza_p11.net_bonus, endorsement.net_bonus, "Prima neta"), renderAmountDiff((_endorsement$poliza_p12 = endorsement.poliza_params) === null || _endorsement$poliza_p12 === void 0 ? void 0 : (_endorsement$poliza_p13 = _endorsement$poliza_p12.commission) === null || _endorsement$poliza_p13 === void 0 ? void 0 : _endorsement$poliza_p13.iva, endorsement.iva, "IVA"), renderAmountDiff((_endorsement$poliza_p14 = endorsement.poliza_params) === null || _endorsement$poliza_p14 === void 0 ? void 0 : (_endorsement$poliza_p15 = _endorsement$poliza_p14.commission) === null || _endorsement$poliza_p15 === void 0 ? void 0 : _endorsement$poliza_p15.total_bonus, endorsement.total_bonus, "Prima total"));
  };

  var renderDiff = function renderDiff() {
    var _endorsement$poliza_p16, _endorsement$differen, _endorsement$differen2, _endorsement$poliza_p17, _endorsement$differen3, _endorsement$differen4;

    if (endorsement.poliza_params) {
      switch (endorsement.endorsement_type) {
        case "increase_amount":
        case "decrease_amount":
          return /*#__PURE__*/React.createElement("dl", {
            className: "dl-horizontal"
          }, renderAmountCommissionDiff());

        case "minute":
        case "reenable":
        case "annulment":
          return /*#__PURE__*/React.createElement("dl", {
            className: "dl-horizontal"
          }, renderCommissionDiff());

        case "cancellation":
          return /*#__PURE__*/React.createElement("dl", {
            className: "dl-horizontal"
          }, /*#__PURE__*/React.createElement("dt", null, "Fecha de cancelaci\xF3n:"), /*#__PURE__*/React.createElement("dd", null, getFormattedDate((_endorsement$poliza_p16 = endorsement.poliza_params) === null || _endorsement$poliza_p16 === void 0 ? void 0 : _endorsement$poliza_p16.finish_date), " ", /*#__PURE__*/React.createElement("small", {
            className: "text-danger"
          }, "(", (_endorsement$differen = endorsement.differences) === null || _endorsement$differen === void 0 ? void 0 : (_endorsement$differen2 = _endorsement$differen.extension) === null || _endorsement$differen2 === void 0 ? void 0 : _endorsement$differen2.difference, " d\xEDas)")), renderCommissionDiff());

        case "extension":
          return /*#__PURE__*/React.createElement("dl", {
            className: "dl-horizontal"
          }, /*#__PURE__*/React.createElement("dt", null, "Pr\xF3rroga a:"), /*#__PURE__*/React.createElement("dd", null, getFormattedDate((_endorsement$poliza_p17 = endorsement.poliza_params) === null || _endorsement$poliza_p17 === void 0 ? void 0 : _endorsement$poliza_p17.finish_date), " ", /*#__PURE__*/React.createElement("small", {
            className: "text-success"
          }, "(+", (_endorsement$differen3 = endorsement.differences) === null || _endorsement$differen3 === void 0 ? void 0 : (_endorsement$differen4 = _endorsement$differen3.extension) === null || _endorsement$differen4 === void 0 ? void 0 : _endorsement$differen4.difference, " d\xEDas)")), renderCommissionDiff());

        case "change_beneficiary":
          return renderUser("beneficiario");

        case "change_contractor":
          return renderUser("contractor");

        case "change_person_information":
          return renderUser("asegurado");

        default:
          return null;
      }
    }
  };

  var renderUser = function renderUser(user_type) {
    return /*#__PURE__*/React.createElement("small", null, endorsement.poliza_params && JSON.stringify(endorsement.poliza_params[user_type]));
  };

  var renderStatusLabel = function renderStatusLabel() {
    switch (endorsement.aasm_state) {
      case "pending":
        return /*#__PURE__*/React.createElement("span", {
          className: "label label-default"
        }, endorsement.status_name);

      case "approved":
        return /*#__PURE__*/React.createElement("span", {
          className: "label label-success"
        }, endorsement.status_name);

      case "rejected":
        return /*#__PURE__*/React.createElement("span", {
          className: "label label-danger"
        }, endorsement.status_name);
    }
  };

  var renderStatus = function renderStatus() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderStatusLabel(), /*#__PURE__*/React.createElement("small", {
      className: "text-muted"
    }, last_update_by));
  };

  var renderInformation = function renderInformation() {
    return /*#__PURE__*/React.createElement("small", {
      title: endorsement.created_at
    }, "Creado por ", endorsement.created_by_email);
  };

  var renderFile = function renderFile() {
    var _endorsement$endorsem, _endorsement$endorsem2, _endorsement$endorsem3, _endorsement$endorsem4;

    return /*#__PURE__*/React.createElement(React.Fragment, null, isAbleToEdit && canApproveAndReject && /*#__PURE__*/React.createElement(FilePond, {
      stylePanelLayout: "compact",
      onprocessfile: refreshEndorsement,
      onremovefile: refreshEndorsement,
      allowMultiple: false,
      maxFiles: 1,
      server: "/api/v1/poliza_endorsements/".concat(endorsement.id, "/update_document"),
      name: "endorsement_document",
      labelIdle: "<span class=\"filepond--label-action\">Subir</span> endoso",
      allowRevert: true,
      credits: false
    }), ((_endorsement$endorsem = endorsement.endorsement_document) === null || _endorsement$endorsem === void 0 ? void 0 : (_endorsement$endorsem2 = _endorsement$endorsem.endorsement_document) === null || _endorsement$endorsem2 === void 0 ? void 0 : _endorsement$endorsem2.url) && /*#__PURE__*/React.createElement("a", {
      href: endorsement.endorsement_document.endorsement_document.url,
      style: {
        fontSize: "xx-small"
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "glyphicon glyphicon-file"
    }), getEndorsementDocumentFilename((_endorsement$endorsem3 = endorsement.endorsement_document) === null || _endorsement$endorsem3 === void 0 ? void 0 : (_endorsement$endorsem4 = _endorsement$endorsem3.endorsement_document) === null || _endorsement$endorsem4 === void 0 ? void 0 : _endorsement$endorsem4.url.split("/"))));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col",
    title: endorsement.created_at
  }, /*#__PURE__*/React.createElement("a", {
    href: "/admin/poliza_endorsements/".concat(endorsement.id),
    target: "_blank",
    className: "btn btn-primary",
    title: "Ver endoso"
  }, endorsement.id)), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("span", {
    className: "badge"
  }, "Correlativo: ", endorsement.consecutive_number)), /*#__PURE__*/React.createElement("div", {
    className: "col col-sm-1 text-center"
  }, endorsement.endorsement_type_name, endorsement.cancel_reason && /*#__PURE__*/React.createElement("span", null, "(".concat(endorsement.cancel_reason_name, ")"))), /*#__PURE__*/React.createElement("div", {
    className: "col col-sm-1",
    title: last_update_by
  }, renderStatus()), /*#__PURE__*/React.createElement("div", {
    className: "col col-sm-3 text-center"
  }, renderDiff()), /*#__PURE__*/React.createElement("div", {
    className: "col col-sm-1 text-center"
  }, endorsement.commentary), /*#__PURE__*/React.createElement("div", {
    className: "col col-sm-1 text-center"
  }, renderInformation()), /*#__PURE__*/React.createElement("div", {
    className: "col col-sm-2 text-center"
  }, renderFile()), /*#__PURE__*/React.createElement("div", {
    className: "col col-sm-1"
  }, isAbleToEdit && hasEditPermission && /*#__PURE__*/React.createElement("a", {
    href: "/admin/poliza_endorsements/".concat(endorsement.id, "/edit"),
    className: "btn btn-primary",
    title: "Editar"
  }, /*#__PURE__*/React.createElement("i", {
    className: "glyphicon glyphicon-edit"
  }), "Editar"), canApproveAndReject && renderApproveButton(), canApproveAndReject && renderRejectButton()));
};

export default PolizaEndorsementListItem;